import { LinereuseInfoResponse } from '@/types/api/mypage/lineReuseInfo';
import api from '@/utils/api';
import { getSigV4HeadersForGet } from '@/utils/cognito';
import { insertServiceIdInApiUrlSync } from '@/utils/common';
import { ApiUrl } from '@/utils/constants';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import useInsertServiceIdInApiUrl from '../useInsertServiceIdInApiUrl';

/** 回線再利用情報取得APIのURL */
const url = ApiUrl.Read.LINE_REUSE_INFO;

/**
 * 回線再利用情報取得APIの呼び出しフック。
 * 既存回線の引き継ぎ可否や表示情報を取得する。
 *
 * @returns execute - API実行関数
 */
const useGetLineReuseInfo = () => {
  const { insertServiceIdInApiUrl } = useInsertServiceIdInApiUrl();
  const execute = useCallback(
    async (serviceId?: string): Promise<AxiosResponse<LinereuseInfoResponse>> => {
      let apiUrlWithServiceId = insertServiceIdInApiUrl(url);
      if (serviceId) {
        // ログイン直後など非同期 state 参照が間に合わない経路では明示 serviceId を優先する。
        apiUrlWithServiceId = insertServiceIdInApiUrlSync(url, serviceId);
      }
      const headers = await getSigV4HeadersForGet(apiUrlWithServiceId);
      return api.get(apiUrlWithServiceId, headers);
    },
    []
  );

  return { execute };
};

export default useGetLineReuseInfo;
